import { PhoneCall, UserCheck, Navigation, Wrench, FileText } from "lucide-react";

export default function HowItWorks() {
  const steps = [
    {
      icon: <PhoneCall size={28} />,
      title: "Raise Request",
      desc: "Enter vehicle & location details in seconds"
    },
    {
      icon: <UserCheck size={28} />,
      title: "Vendor Assigned",
      desc: "Nearest verified partner automatically selected"
    },
    {
      icon: <Navigation size={28} />,
      title: "Track Driver",
      desc: "Live ETA & movement tracking"
    },
    {
      icon: <Wrench size={28} />,
      title: "On-Site Assistance",
      desc: "Crane, mechanic or legal support dispatched"
    },
    {
      icon: <FileText size={28} />,
      title: "Closure & Reports",
      desc: "Inspection, documents & claim support"
    }
  ];

  return (
    <section className="bg-[#020617] text-white py-24 relative overflow-hidden">

      <div className="max-w-7xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-5xl font-semibold">
          How Assistance Reaches You
        </h2>
        <p className="text-slate-400 mt-4 max-w-2xl mx-auto">
          A structured response system that coordinates vendors, drivers and support teams
          in real time — so you’re never stuck waiting without updates.
        </p>

        {/* timeline */}
        <div className="mt-16 grid md:grid-cols-5 gap-8 relative">

          {/* connecting line */}
          <div className="hidden md:block absolute top-10 left-0 right-0 h-[2px] bg-slate-800" />

          {steps.map((step, index) => (
            <Step key={index} step={step} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}

function Step({ step, index }) {
  return (
    <div className="relative group">
      
      {/* icon circle */}
      <div className="mx-auto w-16 h-16 rounded-full bg-slate-900 border border-slate-800 
      flex items-center justify-center text-[#21A6E9]
      group-hover:bg-[#21A6E9] group-hover:text-white transition duration-300 shadow-lg shadow-black/40">

        {step.icon}
      </div>

      {/* step number */}
      <div className="text-xs text-slate-500 mt-4">
        STEP {index + 1}
      </div>

      <h3 className="mt-2 text-lg font-medium">
        {step.title}
      </h3>

      <p className="text-slate-400 text-sm mt-2 max-w-[200px] mx-auto">
        {step.desc}
      </p>
    </div>
  );
}
